<!-- do not reapply safeHtml pipe as it was causing a secutiry issue falgged in Pen Testing https://wealthdynamixltd.atlassian.net/browse/CLMI-5325 -->
<div
    data-cy="wdx-audit-value-label"
    [class.fw-bold]="subtitle || badge"
    [innerHtml]="label | translateTokenisedString | markdownToHtml"
></div>

<div class="d-flex">
    @if (subtitle) {
        <div data-cy="wdx-audit-value-subtitle" [class.me-2]="subtitle">
            {{ subtitle }}
        </div>
    }

    @if (badge) {
        <wdx-badge
            data-cy="wdx-audit-value-badge"
            [themeColor]="badge.themeColor ?? null"
        >
            {{ badge.label }}
        </wdx-badge>
    }
</div>
